import { Modal } from 'antd';
import { useEffect, useState } from 'react';
import QRCode from 'react-qr-code';
import styled from 'styled-components';

import useAccessBadge from '../hooks/useAccessBadge';

const DebugQRCode = () => {
  const [isVisible, setIsVisible] = useState(false);
  const { accessBadge } = useAccessBadge();

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      // Check for Ctrl+Shift+I (or Cmd+Shift+I on Mac)
      if ((event.ctrlKey || event.metaKey) && event.shiftKey && event.key === 'I') {
        event.preventDefault();
        setIsVisible(prev => !prev);
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, []);

  const currentUrl = typeof window !== 'undefined' ? window.location.href : '';

  // Display values
  const userId = accessBadge?.user?.id || 'Not logged in';
  const organizationId = accessBadge?.organization?.id || 'N/A';

  // Create a simplified debug info object for the QR code
  const debugInfo = {
    userId: accessBadge?.user?.id || null,
    organizationId: accessBadge?.organization?.id || null,
    url: currentUrl,
    preferredLocale: accessBadge?.user?.preferredLocale || null,
    licenseCoarseLevel: accessBadge?.license?.coarseLevel || null,
    licenseFineLevel: accessBadge?.license?.fineLevel || null,
    role: accessBadge?.role || null,
    createdAt: new Date().toISOString(),
  };

  // Encode as JSON string for the QR code
  const qrData = JSON.stringify(debugInfo);

  return (
    <Modal
      visible={isVisible}
      onCancel={() => setIsVisible(false)}
      footer={null}
      width={500}
      centered
      title="Debug Information"
    >
      <ModalContent>
        <QRCodeWrapper>
          <QRCode value={qrData} size={400} />
        </QRCodeWrapper>
        <DebugDetails>
          <DetailRow>
            <Label>User ID:</Label>
            <Value>{userId}</Value>
          </DetailRow>
          <DetailRow>
            <Label>URL:</Label>
            <Value>{currentUrl}</Value>
          </DetailRow>
          <DetailRow>
            <Label>Organization ID:</Label>
            <Value>{organizationId}</Value>
          </DetailRow>
        </DebugDetails>
        <Instructions>
          Scan this QR code to capture debug information for support.
        </Instructions>
        <KeyboardHint>Press Ctrl+Shift+I (or Cmd+Shift+I) to toggle</KeyboardHint>
      </ModalContent>
    </Modal>
  );
};

const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
`;

const QRCodeWrapper = styled.div`
  padding: 20px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
`;

const DebugDetails = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 10px;
  background: #f5f5f5;
  border-radius: 4px;
`;

const DetailRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const Label = styled.span`
  font-weight: 600;
  font-size: 12px;
  color: #666;
`;

const Value = styled.span`
  font-size: 14px;
  color: #333;
  word-break: break-all;
`;

const Instructions = styled.p`
  text-align: center;
  color: #666;
  font-size: 14px;
  margin: 0;
`;

const KeyboardHint = styled.p`
  text-align: center;
  color: #999;
  font-size: 12px;
  margin: 0;
  font-style: italic;
`;

export default DebugQRCode;
